/**
 * Country centroids for map visualization
 * Format: [latitude, longitude]
 */
export const COUNTRY_COORDS: Record<string, [number, number]> = {
  // North America
  US: [37.0902, -95.7129],
  CA: [56.1304, -106.3468],
  MX: [23.6345, -102.5528],

  // South America
  BR: [-14.235, -51.9253],
  AR: [-38.4161, -63.6167],
  CL: [-35.6751, -71.543],
  CO: [4.5709, -74.2973],
  PE: [-9.19, -75.0152],
  VE: [6.4238, -66.5897],

  // Europe
  GB: [55.3781, -3.436],
  FR: [46.2276, 2.2137],
  DE: [51.1657, 10.4515],
  IT: [41.8719, 12.5674],
  ES: [40.4637, -3.7492],
  PT: [39.3999, -8.2245],
  NL: [52.1326, 5.2913],
  BE: [50.5039, 4.4699],
  SE: [60.1282, 18.6435],
  NO: [60.472, 8.4689],
  DK: [56.2639, 9.5018],
  PL: [51.9194, 19.1451],
  CH: [46.8182, 8.2275],
  AT: [47.5162, 14.5501],
  IE: [53.4129, -8.2439],

  // Asia
  CN: [35.8617, 104.1954],
  JP: [36.2048, 138.2529],
  IN: [20.5937, 78.9629],
  KR: [35.9078, 127.7669],
  SG: [1.3521, 103.8198],
  MY: [4.2105, 101.9758],
  TH: [15.87, 100.9925],
  ID: [-0.7893, 113.9213],
  PH: [12.8797, 121.774],
  VN: [14.0583, 108.2772],
  HK: [22.3193, 114.1694],
  TW: [23.6978, 120.9605],

  // Middle East
  AE: [23.4241, 53.8478],
  SA: [23.8859, 45.0792],
  IL: [31.0461, 34.8516],
  TR: [38.9637, 35.2433],

  // Africa
  ZA: [-30.5595, 22.9375],
  EG: [26.8206, 30.8025],
  NG: [9.082, 8.6753],
  KE: [-0.0236, 37.9062],

  // Oceania
  AU: [-25.2744, 133.7751],
  NZ: [-40.9006, 174.886]
}

/**
 * Get country name from country code
 */
export const COUNTRY_NAMES: Record<string, string> = {
  US: 'United States',
  CA: 'Canada',
  MX: 'Mexico',
  BR: 'Brazil',
  AR: 'Argentina',
  CL: 'Chile',
  CO: 'Colombia',
  PE: 'Peru',
  VE: 'Venezuela',
  GB: 'United Kingdom',
  FR: 'France',
  DE: 'Germany',
  IT: 'Italy',
  ES: 'Spain',
  PT: 'Portugal',
  NL: 'Netherlands',
  BE: 'Belgium',
  SE: 'Sweden',
  NO: 'Norway',
  DK: 'Denmark',
  PL: 'Poland',
  CH: 'Switzerland',
  AT: 'Austria',
  IE: 'Ireland',
  CN: 'China',
  JP: 'Japan',
  IN: 'India',
  KR: 'South Korea',
  SG: 'Singapore',
  MY: 'Malaysia',
  TH: 'Thailand',
  ID: 'Indonesia',
  PH: 'Philippines',
  VN: 'Vietnam',
  HK: 'Hong Kong',
  TW: 'Taiwan',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  IL: 'Israel',
  TR: 'Turkey',
  ZA: 'South Africa',
  EG: 'Egypt',
  NG: 'Nigeria',
  KE: 'Kenya',
  AU: 'Australia',
  NZ: 'New Zealand'
}
